export default __webpack_public_path__ + "static/media/checkbox.af882c7f.mp3";